module.exports = __webpack_public_path__ + "static/media/edit.0182abd0.svg";